<template>
    <van-popup v-model="show"
               position="bottom"
               closeable
               @click-overlay="onClose"
               @click-close-icon="onClose"
               :close-on-click-overlay="false"
               :style="{
                    position: 'absolute',
               }"
               :overlay-style="{
                    zIndex: 1000,
                    position: 'absolute',
                    background: 'rgba(0,0,0,0.3)'
               }"
               get-container="body"
    >
        <div class="minisite-privacy-content"
             :style="getWrapperStyle">
            <basic-text :data="data.contents[0].text.contents"></basic-text>
            <div class="privacy-buttons flex gap-20">
                <div class="privacy-button" :style="data.style.buttonStyle.confirm" @click="onConfirm">
                    {{ data.style.buttonStyle.confirm.text }}
                </div>
                <div class="privacy-button" @click="onCancel" :style="data.style.buttonStyle.cancel">{{ data.style.buttonStyle.cancel.text
                    }}
                </div>
            </div>
        </div>
    </van-popup>

</template>

<script>
    import Vue from "vue"
    import { Popup } from "vant"
    import PrivacyMixIn from "./privacy.mixin"

    Vue.use(Popup)

    export default {
        name: "Template00",
        mixins: [PrivacyMixIn],
        props: {
            data: {}
        },
        data() {
            return {}
        },
        computed: {}
    }
</script>

<style lang="less">
    .minisite-privacy-content {

        img {
            max-width: 100%;
            height: auto;
        }

        .image_resized {
            width: initial;
            display: flex;
            margin: 0;
        }

        figure {
            &.image {
                text-align: center;
                margin: 0;

                img {
                    max-width: 100%;
                }
            }
        }

        .privacy-buttons {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            gap: 20px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;

            .privacy-button {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-grow: 1;
                padding: 8px 10px;
                border-radius: 50px;
                max-width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }
    }
</style>
